<template>
  <div class="box box-danger">
    <div style="margin-top: 5px">
      <ul class="nav nav-tabs">
        <li class="active">
          <a data-toggle="tab" href="#userAdd"
            ><b>{{ $t("user.profile") }}</b></a
          >
        </li>
        <li
          v-if="
            parseInt($route.params.id) &&
              GET_ENABLE_MODULE_AND_EXTRA_INFO_DATA.extra_info_list !==
                undefined &&
              GET_ENABLE_MODULE_AND_EXTRA_INFO_DATA.extra_info_list.includes(
                keyCheckShowApartmentExtraInfo
              )
          "
          @click="onClickTabSelect(2)"
        >
          <a data-toggle="tab" href="#userExtraInfo"
            ><b>{{ $t("userExtraInfo.title") }}</b></a
          >
        </li>
      </ul>
      <div class="tab-content">
        <div id="userAdd" class="tab-pane fade in active">
          <user-add ref="userAdd" />
        </div>
        <div
          v-if="parseInt($route.params.id)"
          id="userExtraInfo"
          class="tab-pane fade"
        >
          <user-extra-info ref="userExtraInfo" />
        </div>
      </div>
    </div>
    <!--  -->
  </div>
</template>
<script>
import UserExtraInfo from "./UserExtraInfo";
import UserAdd from "./UserAdd";
import { mapGetters } from 'vuex';
import Enum from "../../../enum/enum";
export default {
  components: {
    UserExtraInfo,
    UserAdd
  },
  data: () => ({
    keyCheckShowApartmentExtraInfo: Enum.defaultExtraInfoList.USER_EXTRA_INFO
  }),
  computed: {
    ...mapGetters([
      "GET_ENABLE_MODULE_AND_EXTRA_INFO_DATA"
    ])
  },
  methods: {
    onClickTabSelect: function(value) {
      switch (value) {
        case 2:
          this.$refs.userExtraInfo.getRefreshData(parseInt(this.$route.params.id))
          break;
        default:
          break;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.nav-tabs > li.active > a,
.nav-tabs > li.active > a:hover,
.nav-tabs > li.active > a:focus {
  background: #337ab7;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/views/User/UserInfoTabs.vue